import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Button, Popover, Typography } from '@mui/material';
import { useState } from 'react';

// Hover popover, matching ManualAdjustmentDialog. pointerEvents none so the panel dismisses on
// cursor-out rather than trapping the pointer.
const RecallHowItWorks = () => {
  const [anchor, setAnchor] = useState(null);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Button
        size='small'
        variant='text'
        color='info'
        startIcon={<InfoOutlinedIcon />}
        sx={{ textTransform: 'none' }}
        onMouseEnter={(event) => setAnchor(event.currentTarget)}
        onMouseLeave={() => setAnchor(null)}
      >
        How it works
      </Button>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        onClose={() => setAnchor(null)}
        disableRestoreFocus
        sx={{ pointerEvents: 'none' }}
        slotProps={{
          paper: {
            sx: {
              maxWidth: 440,
              borderLeft: '4px solid',
              borderColor: 'info.main',
              p: 2,
              pointerEvents: 'none',
            },
          },
        }}
      >
        <Typography variant='body2' color='text.secondary' component='ol' sx={{ m: 0, pl: 2.5 }}>
          <li style={{ marginBottom: 6 }}>
            Reserved quantity on the selected lots goes straight back into inventory — it does not
            pass through reversal review.
          </li>
          <li style={{ marginBottom: 6 }}>
            The line items holding it return to the fill queue and their orders go back to OPEN.
          </li>
          <li style={{ marginBottom: 6 }}>
            A line item that also holds stock on other lots has that returned too — release is per
            line item, so the total can exceed the lots you picked.
          </li>
          <li>Anything that cannot be reversed is listed afterwards with the reason.</li>
        </Typography>
      </Popover>
    </Box>
  );
};

export default RecallHowItWorks;
